import React from 'react'; // get the React object from the react module
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () => import(/* webpackChunkName: 'pollwidget' */ './PollWidgetMain'),
  loading: () => null,
});

class PollWidget extends React.Component {
  constructor() {
    super();
    this.state = { mounted: false };
  }
  componentDidMount() {
    this.setState({ mounted: true });
  }

  render() {
    return this.state.mounted ? <LoadableComponent {...this.props} /> : null;
  }
}

export default PollWidget;
